import { ThisConnector } from '../../../../../api/connector'
import { JiraIntegrationForm } from '../../jira-integration-page/jira-form-schema'
import { mapJiraFormToApi } from '../map-jira-form'

export interface UpdateJiraBugtrackerArgs {
  organizationUuid?: string
  bugtracker: JiraIntegrationForm
  bugtrackerId?: number
}

export interface UpdateJiraBugtrackerResponse {
  data: any
}

export async function updateJiraBugtracker(
  this: ThisConnector,
  { organizationUuid, bugtracker, bugtrackerId }: UpdateJiraBugtrackerArgs
) {
  const formData = mapJiraFormToApi(bugtracker)

  // This is a temporary workaround and is needed since the current backend
  // version does not support those fields in both cases.
  // As soon as this issue is fixed on the backend side the if block below
  // should be removed and instead of passing formData we can put back the mapper.
  if (!formData.serverless) {
    // @ts-ignore
    delete formData.serverless
    // @ts-ignore
    delete formData.serverless_account_ids
    // @ts-ignore
    delete formData.serverless_categories
  }
  const { data } = await this.connector.put<UpdateJiraBugtrackerResponse>(
    `/${organizationUuid}/bugtrackers/jira/${bugtrackerId}?expand=skip_links`,
    formData
  )
  return data
}
